{
  "name": "@recurly/react-recurly",
  "version": "2.0.1",
  "description": "React components for Recurly.js",
  "main": "lib-dist/index.js",
  "types": "types/index.d.ts",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/recurly/react-recurly.git"
  },
  "author": "Recurly",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/recurly/react-recurly/issues"
  },
  "homepage": "https://github.com/recurly/react-recurly#readme",
  "peerDependencies": {
    "react": ">= 18.0.0",
    "react-dom": ">= 18.0.0"
  },
  "dependencies": {
    "@types/recurly__recurly-js": "latest",
    "memoize-one": "^6.0.0",
    "prop-types": "^15.7.2"
  },
  "devDependencies": {
    "@babel/cli": "^7.8.4",
    "@babel/core": "^7.21.8",
    "@babel/plugin-proposal-class-properties": "^7.18.6",
    "@babel/plugin-transform-runtime": "^7.21.4",
    "@babel/preset-env": "^7.21.5",
    "@babel/preset-react": "^7.18.6",
    "@definitelytyped/dtslint": "^0.0.163",
    "@recurly/public-api-test-server": "https://gitpkg.now.sh/recurly/recurly-js/packages/public-api-fixture-server?v4.23.2",
    "@storybook/addon-essentials": "^7.0.24",
    "@storybook/addon-interactions": "^7.0.24",
    "@storybook/addon-links": "^7.0.24",
    "@storybook/blocks": "^7.0.24",
    "@storybook/react": "^7.0.24",
    "@storybook/react-vite": "^7.0.24",
    "@storybook/testing-library": "^0.0.14-next.2",
    "@testing-library/react": "^14.0.0",
    "@types/react": "^18.2.6",
    "babel-loader": "^9.1.2",
    "jest": "^29.5.0",
    "jest-environment-jsdom": "^29.5.0",
    "jest-transform-css": "^6.0.1",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "react-test-renderer": "^18.2.0",
    "recurly.js": "recurly/recurly-js",
    "regenerator-runtime": "^0.13.11",
    "storybook": "^7.0.24"
  },
  "scripts": {
    "prepublishOnly": "babel lib -d lib-dist"
  }
}
